import type { HealthCategoryConsultationStatus } from '@shared/patient-intake-status';

import { FORM_CATEGORIES } from '../../../../../utils/constants.js';
import { parseConsultationStatus } from '../../utils';

export const parseHealthCategories = (userData: Record<string, unknown>): HealthCategoryConsultationStatus =>
  Object.entries(userData.forms ?? ({} as Record<string, unknown>)).reduce<HealthCategoryConsultationStatus>(
    (acc, [category, status]) => {
      if (typeof status !== 'string') {
        return acc;
      }

      // We do not want to parse the checkup status, as it is not a health category
      if (category === FORM_CATEGORIES.CHECKUP) {
        return acc;
      }

      // Nicotine is a Canview-managed flow — its `forms.nicotine` value (e.g.
      // 'awaiting review') doesn't correspond to a real Candor intake state, so we
      // skip it to avoid surfacing it under "Your Intake Status" with copy that
      // refers to Candor nurses/doctors.
      if (category === FORM_CATEGORIES.NICOTINE) {
        return acc;
      }

      return {
        ...acc,
        [category]: parseConsultationStatus(status as string) ?? 'NOT_STARTED',
      };
    },
    {} as HealthCategoryConsultationStatus,
  );
